import React from 'react';
import { SVGAttributes } from 'react';

export const HeartbeatIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.0957 6.36424C2.70604 3.42028 6.33214 1.20632 9.77873 5.11964C14.6973 -0.516975 19.951 6.47195 16.3847 10.0741L9.77873 16.1655L5.91328 12.5753"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 9.58341H4.99183L6.78693 7.18994L9.1804 11.3785L10.9755 8.98504H12.7706"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeartbeatIcon;
